/* globals $ */
export default function calculateOffset (offset) {
  let h = $(window).innerHeight();
  let p = ((offset / 1000)) * h;
  return p;
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/calculateOffset.js